import React from "react";
import { Headphones, Mic, Gauge, Music } from "lucide-react";

const LINE = "Includes play-along & sing-along backing tracks in every course, with tempo & key control, a live score and record-yourself feedback from Jason.";

export const PlayAlongNote = ({ testId = "playalong-note" }) => (
  <p className="mt-3 flex items-start gap-2 text-xs font-medium text-primary" data-testid={testId}>
    <Headphones size={14} className="mt-0.5 shrink-0" /> {LINE}
  </p>
);

const FEATURES = [
  [Headphones, "Backing bands", "Play-along & sing-along tracks — gospel, funk, swing, reggae, ballads and more."],
  [Gauge, "Tempo & key", "Slow it down, speed it up or change key to suit your voice or level."],
  [Music, "Live score", "The notes light up as you play or sing, with a metronome and section looping."],
  [Mic, "Record yourself", "Record a take with the band and send it to Jason for personal feedback."],
];

export const PlayAlongBanner = ({ testId = "playalong-banner" }) => (
  <section className="mt-14 rounded-3xl border border-primary/40 bg-card p-8" data-testid={testId}>
    <p className="font-mono text-xs uppercase tracking-[0.25em] text-primary">In every course</p>
    <h2 className="mt-2 font-serif text-3xl">Play along. Sing along. Record yourself.</h2>
    <p className="mt-2 max-w-2xl text-muted-foreground">{LINE}</p>
    <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {FEATURES.map(([Icon, t, d]) => (
        <div key={t} className="rounded-2xl border border-border bg-background p-5">
          <Icon size={20} className="text-primary" />
          <p className="mt-3 font-semibold">{t}</p>
          <p className="mt-1 text-sm text-muted-foreground">{d}</p>
        </div>
      ))}
    </div>
  </section>
);
